import { LOGIN_BANNER_URL, appAssetUrl } from "./staticAssets";

const img = (relativePath) => appAssetUrl(`Images/${relativePath}`);

const SignInImages = {
  sideImg: img("SignIn/sideimage.png"),
  whiteLogo: img("SignIn/White-logo.png"),
  ovalwithtext: img("SignIn/ovalwithtext.png"),
  google: img("SignIn/google.png"),
  facebook: img("SignIn/facebook.png"),
  icloud: img("SignIn/icloud.png"),
  playstore: img("SignIn/playstore.png"),
  appstore: img("SignIn/appstore.png"),
  eye: img("SignIn/eye.png"),
  google1: img("SignIn/google1.svg"),
  wljloginbanner: LOGIN_BANNER_URL,
  apple: img("Settings/apple.png"),
};

const header = {
  mainLogo: img("Header/logo-removebg 1.png"),
  search: img("Header/Ellipse 1.png"),
  lightMode: img("Header/sun.png"),
  darkMode: img("Header/moon.png"),
  notification: img("Header/notification-bing.png"),
  message: img("Header/message.png"),
  messageError: img("People/No chat.png"),
  user: img("Header/Rectangle 34625130.png"),
  WeLinkWhite: img("Resume/Main logo white 1.png"),
  ad2: img("JobSearch/ad2.png"),
  ad1: img("JobSearch/ad1.png"),
  oglogo: img("Header/welinkjobs-og-logo.png"),
  whiteoglogo: img("Header/welinkjobs-white-logo.png"),
};

const icons = {
  news: img("side-icons/i.png"),
  connection: img("side-icons/i1.png"),
  company: img("side-icons/i2.png"),
  companies: img("side-icons/i3.png"),
  people: img("side-icons/i4.png"),
  searchJob: img("side-icons/i5.png"),
  manageJob: img("side-icons/i6.png"),
  downArrow: img("side-icons/i7.png"),
  about: img("side-icons/i8.png"),
  accessibility: img("side-icons/i9.png"),
  helpcenter: img("side-icons/i10.png"),
  privacy: img("side-icons/i11.png"),
  advertising: img("side-icons/i12.png"),
  business: img("side-icons/i13.png"),
  app: img("side-icons/i14.png"),
  copyright: img("side-icons/i15.png"),
  profile: img("side-icons/Profile-Picture.png"),
  follow: img("side-icons/i16.png"),
  default: img("side-icons/default.png"),
  plus: img("side-icons/i17.png"),
};

const generalsetting = {
  setting: img("Settings/setting.png"),
  icon1: img("Settings/Settingicon1.svg"),
  icon2: img("Settings/Settingicon2.svg"),
  icon3: img("Settings/Settingicon3.svg"),
  icon4: img("Settings/Settingicon4.svg"),
};

const NewsFeed = {
  Advertise: img("NewsFeed/Canvas-Ad.png"),
  AdImg: img("NewsFeed/adImg.png"),
  AdImg2: img("Job/Ad2.b61efbf7.png"),
  companyLogo: img("NewsFeed/companyLogo.png"),
  FeaturedPost: img("NewsFeed/FeaturedPost.png"),
  postphoto1: img("NewsFeed/Post Photos.png"),
  postphoto2: img("NewsFeed/Post Photos (1).png"),
  postphoto3: img("NewsFeed/Post Photos (2).png"),
  companyLogo1: img("NewsFeed/Shape.png"),
  jobPost: img("NewsFeed/job-post.png"),
  PostUser: img("Post/img_03222023062212.jpg"),
  PostImage: img("Post/1711532263373-image.jpg"),
  PostImage1: img("NewsFeed/post5.jpeg"),
  PostImage2: img("NewsFeed/post6.jpeg"),
  video: img("NewsFeed/3129671-hd_1920_1080_30fps.mp4"),
};

const Profile = {
  Background: img("Profile/Image.png"),
  User: img("Profile/1.png"),
  qr: img("Profile/qr.png"),
  logo: img("Profile/favicon.png"),
  download: img("Profile/download.png"),
  Avatar: img("Profile/user.png"),
};

const resume = {
  logo: img("Resume/logo-removebg 1.png"),
  profileImg: img("Resume/Profile Picture.png"),
  facebook: img("Resume/facebook.png"),
  instagram: img("Resume/instagram.png"),
  book: img("Resume/book.png"),
  degree: img("Resume/degree.png"),
  medal: img("Resume/medal.png"),
  cycle: img("Resume/cycle.png"),
  music: img("Resume/music.png"),
  video: img("Resume/video.png"),
  paint: img("Resume/paint.png"),
  bag: img("Resume/bag.png"),
  viewResume: img("Resume/1695105336158-cropped-image.jpg"),
  barcode: img("Resume/logo1.svg"),
  approved: img("Resume/Approved.png"),
  deleted: img("Resume/Deleted.png"),
  disabled: img("Resume/Disabled.png"),
  recognized: img("Resume/Recognized.png"),
  synced: img("Resume/Synced.png"),
  unregister: img("Resume/Unregistered.png"),
  register: img("Resume/Registered.png"),
  verified: img("Resume/Verified.png"),
  tick: img("Resume/tick.jpg"),
};

const people = {
  profile: img("People/user-one.png"),
  profile1: img("People/Component 3.png"),
  profile2: img("People/Mask group21.png"),
  background: img("People/default-bg.jpg"),
  DefaultProfile: img("People/default-profile.png"),
};

const business = {
  coverImage: img("Business-page/Cover Image.png"),
  metaImage: img("Business-page/meta.png"),
  user1: img("Business-page/Profile Picture/PP3 Copy 7.png"),
  user2: img("Business-page/Profile Picture/PP1 Copy.png"),
  user3: img("Business-page/Profile Picture/PP2 Copy.png"),
  user4: img("Business-page/Profile Picture/PP3 Copy 10.png"),
  user5: img("Business-page/Profile Picture/PP3 Copy 8.png"),
  user6: img("Business-page/Profile Picture/PP3 Copy 9.png"),
  user7: img("Business-page/Profile Picture/PP3.png"),
  user8: img("Business-page/Profile Picture/PP6.png"),
  user9: img("Business-page/Profile Picture/PP7.png"),
  user10: img("Business-page/Profile Picture/PP9.png"),
  saveImage: img("Business-page/Path.png"),
  postImage1: img("Business-page/Post/Group 2.png"),
  postImage2: img("Business-page/Post/Post Photos (1).png"),
  postImage3: img("Business-page/Post/Post Photos.png"),
  postUserImage1: img("Business-page/Post/user1.png"),
  postUserImage2: img("Business-page/Post/user2.png"),
  postUserImage3: img("Business-page/Post/user3.png"),
  mediaImage: img("Business-page/Media/Media.png"),
  mediaImage1: img("Business-page/Media/Media (1).png"),
  mediaImage2: img("Business-page/Media/Media (2).png"),
  mediaImage3: img("Business-page/Media/Media (3).png"),
  mediaImage4: img("Business-page/Media/Media (4).png"),
  mediaImage5: img("Business-page/Media/Media (5).png"),
  mediaImage6: img("Business-page/Media/Media (6).png"),
  mediaImage7: img("Business-page/Media/Media (7).png"),
};

const JobSearch = {
  ad1: img("JobSearch/ad1.png"),
  ad2: img("JobSearch/ad2.png"),
  jobLogo: img("JobSearch/joblogo.png"),
  companyHeader: img("JobSearch/JobList/Company Header.png"),
  companySubImg: img("JobSearch/JobList/Logo (2).png"),
  collapsImage: img("JobSearch/JobList/jobListUsers/PP (1).png"),
  collapsImage1: img("JobSearch/JobList/jobListUsers/PP Copy 2.png"),
  collapsImage2: img("JobSearch/JobList/jobListUsers/PP Copy 3.png"),
  collapsImage3: img("JobSearch/JobList/jobListUsers/PP Copy.png"),
  collapsImage4: img("JobSearch/JobList/jobListUsers/PP.png"),
};

const FeatureImages = {
  card1: img("JobSearch/FeatuerCard/Logo (1).png"),
  card2: img("JobSearch/FeatuerCard/Logo (2).png"),
  card3: img("JobSearch/FeatuerCard/Logo (3).png"),
  card4: img("JobSearch/FeatuerCard/Logo (4).png"),
  card5: img("JobSearch/FeatuerCard/Logo (5).png"),
  card6: img("JobSearch/FeatuerCard/Logo (6).png"),
  card7: img("JobSearch/FeatuerCard/Logo (7).png"),
  card8: img("JobSearch/FeatuerCard/Logo.png"),
  card9: img("JobSearch/FeatuerCard/Shape.png"),
  card10: img("JobSearch/FeatuerCard/dribbble (1).png"),
  card11: img("JobSearch/FeatuerCard/dribbble.png"),
  card12: img("JobSearch/FeatuerCard/Rectangle 92.png"),
};

const notificationImages = {
  reStoreIcon: img("JobNotification/restoreIcon.png"),
  deleteIcon: img("JobNotification/deleteIcon.png"),
  notifyImg1: img("JobNotification/Vector (1).png"),
  notifyImg2: img("JobNotification/Vector.png"),
  notifyImg3: img("JobNotification/downloading.png"),
  notifyImg4: img("JobNotification/view.png"),
  notifyImg5: img("JobNotification/Recent Company.png"),
  notifyImg6: img("JobNotification/Component 3.png"),
  notifyImg7: img("JobNotification/Mask group.png"),
  notifyImg8: img("JobNotification/Mask group21.png"),
  notifyImg9: img("JobNotification/user-one.png"),
  notifyImg10: img("JobNotification/image 2.png"),
  notifyImg11: img("JobNotification/Recent Company (1).png"),
  notifyImg12: img("JobNotification/Recent Company (2).png"),
  notifyImg13: img("JobNotification/Recent Company (4).png"),
  notifyImg14: img("JobNotification/Recent Company (5).png"),
  notifyImg15: img("JobNotification/Recent Company (6).png"),
  notifyImg16: img("JobNotification/Recent Company1.png"),
  notifyImg17: img("JobNotification/Recent Company33.png"),
  notifyImg18: img("JobNotification/Recent Company.png"),
};

const blogs = {
  menu: img("Blogs/Shape.png"),
  menu1: img("Blogs/Shape (2).png"),
  menu2: img("Blogs/ic_Grantt.png"),
  blogsImage: img("Blogs/download.jpg"),
  blogsImage1: img("Blogs/blogsImage.jpg"),
  blogsCardImage1: img("Blogs/cardImg (1).jpg"),
  blogsCardImage2: img("Blogs/cardImg (2).jpg"),
  blogsCardImage3: img("Blogs/Business Schedule.png"),
};

const helpcenter = {
  helpcenterImage: img("HelpCenterCard/getting-started.png"),
};

const userAuthImage = {
  dummy: img("UserAuth/Rectangle 34625145.png"),
  dummy1: img("UserAuth/Rectangle 34625146.png"),
};

const connection = {
  locationIcon: img("connection/locationIcon.png"),
  msgIcon: img("connection/msgIcon.png"),
};

const activities = {
  timelinePhoto1: img("Activities/Activities_timeline_Photo1.jpg"),
  timelinePhoto2: img("Activities/Activities_timeline_Photo2.jpg"),
  timelinePhoto3: img("Activities/Activities_timeline_Photo3.jpg"),
  timelinePhoto4: img("Activities/Activities_timeline_Photo4.jpg"),
};

const svg = {
  pin: img("svg/pin.svg"),
  work: img("svg/icon_work.svg"),
};

const post = {
  like: img("Post/f4ly07ldn7194ciimghrumv3l.svg"),
  celebrate: img("Post/3c4dl0u9dy2zjlon6tf5jxlqo.svg"),
  support: img("Post/9whrgl1hq2kfxjqr9gqwoqrdi.svg"),
  love: img("Post/asmf650x603bcwgefb4heo6bm.svg"),
  loader: img("LoaderImage/wlj-loader.gif"),
  insightful: img("Post/39axkb4qe8q95ieljrhqhkxvl.svg"),
  funny: img("Post/ktcgulanbxpl0foz1uckibdl.svg"),
  error: img("Post/404-Error.jpeg"),
  errorSmall: img("Post/No-File-small.png"),
  noimgavailable: img("Post/no-image-available.jpg"),
  errorbig: img("Post/No-File-big.png"),
  LikeGif: img("Post/Like.gif"),
  LoveGif: img("Post/Love.gif"),
  LaughingGif: img("Post/Laughing.gif"),
  WowGif: img("Post/Wow.gif"),
  AngryGif: img("Post/Angry.gif"),
  dot: img("Post/dot.png"),
  likegif: img("Post/Animation - 1714999935336.gif"),
  commentLike: img("Post/8ekq8gho1ruaf8i7f86vd1ftt.svg"),
};

export {
  activities,
  post,
  SignInImages,
  header,
  icons,
  generalsetting,
  NewsFeed,
  resume,
  people,
  Profile,
  business,
  JobSearch,
  userAuthImage,
  notificationImages,
  FeatureImages,
  blogs,
  helpcenter,
  connection,
  svg,
};
